export enum FileReviewSectionType {
    PendingFiles = 'Pending Files',
    FilesToValidate = 'Files to Validate',
    FilesOriginatedPendingValidation = 'Files Originated Pending Validations',
    ActiveAssociatedFiles = 'Active Associated Files',
    PastAssociatedFiles = 'Past Associated Files'
}
